/**
 * THE one small-label treatment for the product.
 *
 * Every surface had its own near-identical costume for a small caps label — the
 * launcher's group headers ran `text-2xs … tracking-wider`, the Clients table's
 * column heads ran `text-xs … tracking-wide`, and the feature screens ran a third
 * size again. Four sizes of the same idea read as a template, not a voice, so the
 * product now has ONE: the string the kit's own `TableHead` already ships
 * (`packages/ui/src/Table.tsx`). The kit is the authority; this constant is the
 * app-side name for it so a screen that cannot reach for `<TableHead>` still gets
 * the same label rather than inventing a fifth.
 *
 * Any surface reaching for a small caps label — a group header, a column head, a
 * definition term, a menu section — uses this and nothing else.
 *
 * ⚠ COUNTERPART: the Clients app declares the SAME treatment under its own name,
 * `COLUMN_LABEL` in `apps/dashboard/src/features/clients/labelStyles.ts`. The two
 * class sets are identical on purpose, both lifted from the kit's `TableHead`
 * (`packages/ui/src/Table.tsx`), which stays the authority for the value. Two
 * names for one treatment can drift silently, so a change to either one is a
 * change to the kit primitive first and then to BOTH of these — never to one.
 */
export const SMALL_LABEL_CLASS =
  'text-2xs font-semibold uppercase tracking-wide text-muted-foreground';
